import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, Modal, Button } from 'reactstrap';

const ModalClickable = (props) => {
  const [modalState, setModalState] = useState(true);

  const handleModalState = () => {
    setModalState(false);
    if (props.url) {
      window.location.href = props.url;
    }
    if (props.function) {
      props.function(false);
    }
  };

  // Valores robustos: si no existen, no se muestran
  const mostrarFacturas = typeof props.facturasAgrupadas === 'number';
  const mostrarRecibos = typeof props.totalRecibos === 'number';
  const mostrarImporte = props.totalImporte !== undefined && props.totalImporte !== null;

  return (
    <Modal isOpen={modalState} centered>
      <ModalBody>
        <h4 className="text-center mt-3">{props.header}</h4>

        {/* Datos opcionales robustos */}
        {(mostrarFacturas || mostrarRecibos || mostrarImporte) && (
          <div className="mt-3 text-center">
            {mostrarFacturas && (
              <p>
                Facturas agrupadas: <strong>{props.facturasAgrupadas}</strong>
              </p>
            )}
            {mostrarRecibos && (
              <p>
                Total recibos seleccionados: <strong>{props.totalRecibos}</strong>
              </p>
            )}
            {mostrarImporte && (
              <p>
                Total importe seleccionado: <strong>{props.totalImporte} €</strong>
              </p>
            )}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color={props.color || 'danger'} onClick={handleModalState}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalClickable.propTypes = {
  header: PropTypes.string,
  color: PropTypes.string,
  url: PropTypes.string,
  function: PropTypes.func,
  facturasAgrupadas: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  totalRecibos: PropTypes.number,
  totalImporte: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ModalClickable;
